import React, { useState } from 'react';
import VideoCard from '../cards/VideoCard';
import VideoModal from '../modals/VideoModal';
import { videos } from '../../data/videos';
import './Videos.css';

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const handleVideoClick = (video) => {
    setSelectedVideo(video);
  };

  const handleCloseModal = () => {
    setSelectedVideo(null);
  };

  return (
    <section className="videos">
      <div className="wrap">
        <div className="sechead">
          <span className="kicker">Veja com seus próprios olhos</span>
          <h2>Eles contam a transformação</h2>
          <p>Sem roteiro, sem ator. Donos reais falando o que mudou na empresa deles.</p>
        </div>
        <div className="vgrid">
          {videos.map((video) => (
            <VideoCard
              key={video.id}
              video={video}
              onClick={handleVideoClick}
            />
          ))}
        </div>
        <p className="vnote">▶ Toque para assistir sem sair da página.</p>
      </div>

      <VideoModal
        isOpen={!!selectedVideo}
        youtubeId={selectedVideo?.youtubeId}
        videoSrc={selectedVideo?.videoSrc}
        onClose={handleCloseModal}
      />
    </section>
  );
};

export default Videos;
